import type {
  FeatureConfig,
  FeatureFlagConfig,
} from '@platform/client/features';

const featureModules: Record<string, { default: FeatureConfig }> =
  import.meta.glob('../../../../../features/**/feature.config.tsx', {
    eager: true,
  });

export const defaultFeatureConfigs = Object.values(featureModules).map(
  (module) => module.default,
);

const featureFlagConfigsModules: Record<
  string,
  { default: FeatureFlagConfig }
> = import.meta.glob('../../../../../**/src/feature-flags.config.ts', {
  eager: true,
});

export const defaultFeatureFlagConfigs = Object.values(
  featureFlagConfigsModules,
).map((module) => module.default);
